import DataTable from "../../../components/DataTable";

export default function ReportTable(props) {
  const options = {
    columns: Columns,
    dataSource: props.data,
    rowIdProperty: "ReportNumber",
    isDisableColumnFilter: true,
  };
  return <DataTable {...options} />;
}
const Columns = [
  {
    headerName: "ReportNumber",
    field: "ReportNumber",
    width: 136,
  },
  {
    headerName: "AdHocReportType",
    field: "AdHocReportType",
    width: 136,
  },
  {
    headerName: "Product",
    field: "Product",
    width: 136,
  },
  {
    headerName: "Customer",
    field: "Customer",
    width: 200,
  },

  {
    headerName: "Site",
    field: "Site",
    width: 136,
  },
  {
    headerName: "Unit",
    field: "Unit",
    width: 136,
  },
  {
    headerName: "Model",
    field: "Model",
    width: 136,
  },
  {
    headerName: "Serial",
    field: "Serial",
    width: 136,
  },
  {
    headerName: "Component",
    field: "Component",
    width: 136,
  },

  {
    headerName: "Parked",
    field: "Parked",
    width: 100,
  },
  {
    headerName: "Scrapped",
    field: "Scrapped",
    width: 100,
  },
  {
    headerName: "Archived",
    field: "Archived",
    width: 100,
  },
];
